module.exports = __webpack_public_path__ + "img/video.6630dc71.png";